import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class PhoneNumberService extends BasicService {
  private PHONE_NUMBER_API = config.phone.url;

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }

  public book(session: ISession, notify = true) {
    return this.http
      .post(`${this.PHONE_NUMBER_API}/sessions/${session.id}/phone-bookings?provider=twilio`, {
        webhookUrl: config.phone.webhook
      })
      .map(res =>
        this.extractData(res, notify, {
          success: this.translate.instant('sessions.edit.phone_number.booked_success')
        })
      )
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/phone-number.service.ts